import TextField from "../TextField/TextField";
import Button from "../Button/Button";

const MiniJobCreator = ({ buttonText, fieldPlaceholder }: any) => {
  return (
    <form method="GET" action="https://visualping.io">
      <div className="flex flex-row items-center gap-2">
        <TextField className="w-5/6 lg:w-1/3" placeholder={fieldPlaceholder} size="large" name="url"></TextField>
        <Button>{buttonText}</Button>
      </div>
    </form>
  );
};

export default MiniJobCreator;
